<script type="text/babel">
export default {
    data() {
        return {
            form: new SparkForm({}),
        }
    },

    methods: {
        update() {
            Spark.put(route('api.profile.password.update'), this.form).then(() => {
                Object.assign(this.form, {
                    current_password: '',
                    password: '',
                    password_confirmation: '',
                })
            })
        },
    },
}
</script>
